'use strict';
/* eslint-disable no-undef */
var debounce = require('lodash/debounce');

var PLP_REVAMP_ENABLED = SitePreferences.PLP_REVAMP_ENABLED;
var PLP_REVAMP_FILTERS_ENABLED = SitePreferences.PLP_REVAMP_FILTERS_ENABLED;

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
    $('.filter-type-boolean input').each(function(){
        var booleanID = $(this).attr('id');
        $(this).closest('.refinement').find('label').attr('for',booleanID);
    })
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');

        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });
    updateDom($results, '.refinements');
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}


/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    if (response){
        var $tempDom = $('<div>').append($(response));
        var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
        sortOptions.forEach(function (option) {
            $('option.' + option.id).val(option.url);
        });
    }
}


/**
 * Update filters options URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateFilterOptions(response) {
    if (response) {
        var $results = $(response);
        var specialHandlers = {
            '.refinements': handleRefinements
        };

        // Update DOM elements that do not require special handling
        [
            '.product-grid',
            '.show-more',
            '.filter-bar'
        ].forEach(function (selector) {
            updateDom($results, selector);
        });

        Object.keys(specialHandlers).forEach(function (selector) {
            specialHandlers[selector]($results);
        });
    }
}

function updateUrlPageParam(currentPage) {
    var absUrl = window.location.pathname;
    if(window.location.search.indexOf("page="+currentPage) < 0){
        if (currentPage > 1) {
            var url = absUrl + "?page=" + currentPage;
            window.history.pushState({ path: url }, '', url);
        } else {
            window.history.pushState({ path: absUrl }, '', absUrl);
        }
    }
}

function updateCanonicalUrl(pageNumber) {
    var pageCount = $('.grid-footer').data('page-count');
    $('link[rel=canonical]').attr('href', window.location.href);

    var pathName = window.location.origin + window.location.pathname;
    if (pageNumber > 1) {
        var prevPage = pageNumber - 1;
        var nextPage = pageNumber + 1;
        $('link[rel=prev]').attr('href', prevPage === 1 ? pathName : pathName + '?page=' + prevPage);

        $('link[rel=next]').attr('href', nextPage > pageCount ? '' : pathName + '?page=' + nextPage);
    } else {
        $('link[rel=prev]').attr('href', '');
        $('link[rel=next]').attr('href', pathName + '?page=2');
    }
}

function updateMetaTitleDescription() {
    var pageNumber = $('.grid-footer').data('page-number');
    var metaDescription = $('meta[name=description]').attr('content');
    var metaTitle = $('.title-meta').html();
    if (metaDescription.indexOf('- PAGE') != -1 || metaTitle.indexOf('- PAGE') != -1){
        metaDescription = metaDescription.split('- PAGE')[0];
        metaTitle = metaTitle.split('- PAGE')[0];
    }

    $('.title-meta').html(pageNumber === 1 ? metaTitle : metaTitle + '- PAGE ' + pageNumber);
    $('meta[name=description]').attr('content', pageNumber === 1 ? metaDescription : metaDescription + '- PAGE ' + pageNumber);
    updateUrlPageParam(pageNumber + 1);
    updateCanonicalUrl(pageNumber + 1);
}

function pushDataLayer() {
    var currencyCode = $('.currencyCode').val();
    var productslist = $('.productslistGtm').val();
    if (productslist){
        dataLayer.push({
            'event': 'productlist_view',
            'ecommerce': {
                'currencyCode': currencyCode,
                'impressions': JSON.parse(productslist)
            }
        });
    }
}
function pushEventToDataLayer($event, $site_location) {

    window.dataLayer.push({
        'event': $event,
        'site_location': $site_location
    });

}
function checkPositionLis(){
    var lis = $('ul.product-grid li.scroll0');
    lis.each(function(i){
        var liTop = $(this).offset().top;
        var liBottom = liTop + $(this).height();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        if (liBottom < viewportBottom){
            var metaDescription = $('meta[name=description]').attr('content');
            var metaTitle = $('.title-meta').html();
            if (metaDescription.indexOf('- PAGE') != -1 || metaTitle.indexOf('- PAGE') != -1){
                metaDescription = metaDescription.split('- PAGE')[0];
                metaTitle = metaTitle.split('- PAGE')[0];
            }
            var pageNumber = parseInt(i + 1);
            $('.title-meta').html(pageNumber === 1 ? metaTitle : metaTitle + '- PAGE ' + pageNumber);
            $('meta[name=description]').attr('content', pageNumber === 1 ? metaDescription : metaDescription + '- PAGE ' + pageNumber);
            updateUrlPageParam(i + 1);
            updateCanonicalUrl(i + 1);
        }
    });
}

module.exports = {

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            var $applyFiltersButton = $('.apply-filters button');
            var isFilterSelected = $('.refinements').attr('data-isfilterselected') === 'true';
            var selectedUrl = this.value;
            var applyUrl = isFilterSelected ? $applyFiltersButton.attr('data-url') : selectedUrl;
            $(this).trigger('search:sort', selectedUrl);
            $.ajax({
                url: this.value,
                data: { selectedUrl: selectedUrl},
                method: 'GET',
                success: function (response) {
                    if (!PLP_REVAMP_FILTERS_ENABLED) {
                        $('.product-grid').empty().html(response);
                        updateFilterOptions(response);
                    }

                    if (PLP_REVAMP_FILTERS_ENABLED) {
                        $applyFiltersButton.attr('data-url', applyUrl);
                    }

                    $('body').trigger('LoadSliderImages');
                    $(this).focus();
                    try {
                        var sorting = JSON.parse($('.grid-footer').attr('data-selected-sorting'));
                        if (sorting != '') {
                            dataLayer.push({
                                'sort_type': sorting.id,
                                'event':'sort_by'
                            });
                        }
                    } catch (e) {
                        // TODO: handle exception
                        console.warn('unable to trigger gtm for sorting');
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        var SortOptions = this;
        var isCompleted = true;
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            e.preventDefault();
            if (isCompleted) {
                isCompleted = false;
                $.spinner().start();
                $(this).trigger('search:showMore', e);
                $.ajax({
                    url: showMoreUrl,
                    data: { selectedUrl: showMoreUrl },
                    method: 'GET',
                    success: function (response) {
                        $('.grid-footer').replaceWith(response);
                        SortOptions.updateSortOptions(response);
                        $('html, body').css({
                            'overflow': 'auto'
                        });
                        updateMetaTitleDescription();
                        pushDataLayer();
                        $('body').trigger('UpdateLoadImage');
                        $.spinner().stop();
                        isCompleted = true;
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },
    updateSortOptions
};


$(document).ready(function () {
    if (!PLP_REVAMP_ENABLED) {
        function infiniteScroll() {
            var windowHeight = $(window).height(), userScroll = $(this).scrollTop();
            var lastTileTopOffset =  $('.product-grid .product-tile:eq(' + ($('.product-grid .product-tile').length - 3) + ')').offset().top;

            if (userScroll > ( lastTileTopOffset - windowHeight)) {
                $('#show-more .show-morebtn').click();
            }
        }
        var debounceInfiniteScroll = debounce(infiniteScroll, 200);
        $(window).scroll(function () {
            if ($('#show-more').length) {
                $('#show-more').hide();

                debounceInfiniteScroll();
            }
        });
    }

    setInterval(checkPositionLis, 800);

    $('.promo-plp2').on('click' , function() {
        var dataTrackingValue = $(this).parent().parent().next('a').find('input').attr('data-tracking');
        pushEventToDataLayer(dataTrackingValue,"Category Page");
    });

});